var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('full-calendar',{ref:"myFullCalendar",attrs:{"options":_vm.calendarOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }